import React from 'react';
import OrangeDart from '../assets/icons/OrangeDart.svg';
import OrangeArrow from '../assets/icons/OrangeArrow.svg';
import { useNavigate } from 'react-router-dom';

export default function LifestyleGoals({ goals, context }) {
  const navigate = useNavigate();

  const goToAdvice = () => {
    navigate('/your-advice', { state: { reportContext: context || null } });
  };

  const hasGoals = Array.isArray(goals) && goals.length > 0;
  return (
    <div className="pt-2">
      <div className="flex items-center gap-3 mb-6">
        <img src={OrangeDart} alt="goals" className="w-[31.25px] h-[30px]" />
        <h3 className="text-xl font-poppins font-semibold text-[#2B3133]">
          Lifestyle Goals
        </h3>
      </div>
      {hasGoals && (
        <div
          className="rounded-2xl p-6 mb-6 -mr-[4px]"
          style={{ backgroundColor: '#FFEEE1' }}
        >
          <div className="space-y-4">
            {goals.map((goal, index) => (
              <div key={index} className="flex items-center gap-3">
                <img src={OrangeArrow} alt="arrow" className="w-5 h-4" />
                <span className="text-sm font-poppins font-normal text-[#2B3133]">
                  {goal}
                </span>
              </div>
            ))}
          </div>
        </div>
      )}
      <button
        onClick={goToAdvice}
        className="w-full bg-[#119975] text-white py-4 px-6 rounded-full font-poppins font-medium hover:bg-[#0f8a6b] transition-colors"
      >
        View My Supplements
      </button>
    </div>
  );
}
